const Checkbox = {
  baseStyle: {
    border: '1px solid',
    borderColor: 'text.black',
    pos: 'relative',
    zIndex: 10,
    control: {
      boxSize: '20px',
      pos: 'relative',
      border: '1px solid',
      borderColor: 'line.black',
      borderRadius: '4px',
      boxSizing: 'border-box',
      zIndex: 15,
      _checked: { bgColor: 'bg.black', border: 'none', _hover: { bg: 'bg.black' } },
    },
    icon: { boxSize: '10px', color: 'text.white' },
    label: { textStyle: 'h1', m: '0px' },
    container: { display: 'flex', gap: '16px', _checked: { bgColor: 'bg.grayLight' } },
  },
  variants: {
    error: {
      label: {
        color: 'alert.active',
      },
      control: {
        borderColor: 'alert.active',
        _checked: {
          bgColor: 'alert.active',
        },
      },
    },
  },
};

export default Checkbox;
